module.exports = __webpack_public_path__ + "img/house-night.07ed5142.svg";